import React from "react";
import { useParams } from "react-router-dom";
import MtvContainer from "./MtvContainer/MtvContainer";

const RoomContainer = ({ mtvSetup, ...rest }) => {
  let { id } = useParams();
  if (!id) return <>Room Id must exist</>;
  const settings = { ...mtvSetup, play_rid: id };
  return (
    <>
      <div className="hide">Room ({id})</div>
      <MtvContainer mtvSetup={settings} />
    </>
  );
};

export default RoomContainer;
